document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.cb-purpose-impact');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var image = section.querySelector('.cb-purpose-impact__image');
    if (!image) return;

    if (!image.complete) {
      image.decoding = 'async';
    }
  });
});